const devConfig = {
    venusConfig: {
        client_id: "rpm68z7m4pc4bsjr0000000000de06d6",
        bucket: "brandassets",
        isTest: true
    },
    tagHost: {
        // 测试环境下掉了
        // host: 'http://10.138.232.11:8412/tfs/img_text_rel',
        host: 'https://tmu.sankuai.com/tfs/img_text_rel',
        task: 'cls-xiangsu',
        version: 10,
    },
    s3Config: {
        endpoint: 'msstest.sankuai.com',
        bucket: 'brand-assets-v1',
    },
    brandConfig: {
        host: {
            innerHost: 'http://localhost:3000',
            outerHost: 'http://localhost:3001',
            // innerHost: 'https://brand.bj.ide.test.sankuai.com',
            // outerHost: 'https://brand.bj.ide.test.sankuai.com'
        },
        basePath: {
            innerBasePath: '/assets-internal',
            outerBasePath: '/assets'
        }

    }
}

const testConfig = {
    venusConfig: {
        client_id: "rpm68z7m4pc4bsjr0000000000de06d6",
        bucket: "brandassets",
        isTest: true
    },
    tagHost: {
        host: 'https://tmu.sankuai.com/tfs/img_text_rel',
        task: 'cls-xiangsu',
        version: 10,
    },
    s3Config: {
        endpoint: 'msstest.sankuai.com',
        bucket: 'brand-assets-v1',
    },
    brandConfig: {
        host: {
            innerHost: 'https://brand.mykeeta.test.sankuai.com',
            outerHost: 'https://brand.mykeeta.test.sankuai.com'
        },
        basePath: {
            innerBasePath: '/assets-internal',
            outerBasePath: '/assets'
        }
    }
}

const prodConfig = {
    venusConfig: {
        client_id: "gt68vbzq6gwkrn4m0000000000231b2d",
        bucket: "brandasset",
        isTest: false
    },
    tagHost: {
        host: 'https://tmu.sankuai.com/tfs/img_text_rel',
        task: 'cls-xiangsu',
        version: 10,
    },
    s3Config: {
        endpoint: 's3-ap-hongkong.mykeeta.com',
        bucket: 'brand-assets-v1',
    },
    brandConfig: {
        host: {
            innerHost: 'https://brand.keeta-global.com',
            outerHost: 'https://brand.keeta-global.com'
        },
        basePath: {
            innerBasePath: '/assets-internal',
            outerBasePath: '/assets'
        }
    }
}

export function currentInitConfig() {
    switch (process.env.REACT_APP_DEPLOY_ENV) {
        case 'development':
            return devConfig;
        case 'test':
            return testConfig;
        case 'production':
            return prodConfig;
        default:
            return devConfig;
    }
}